import { useContext } from 'react';

import { RichTextEditorContext } from '../providers/rich-text-editor-provider';
import { type RichTextEditorContextData } from '../providers/types';

export function useRichTextEditor(): RichTextEditorContextData {
  const ctx = useContext(RichTextEditorContext);
  if (ctx === null || ctx === undefined) {
    throw new Error('useRichTextEditor must be used within <RichTextEditorProvider>.');
  }
  return ctx;
}
